import React, { useState, useEffect } from 'react'
import { useForm, Controller } from 'react-hook-form'
import { Panel, Row, Col, FlexboxGrid, ButtonGroup, IconButton, Icon } from 'rsuite'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import AppContext from '../../context/AppContext'
import { cloneDeep, isEmpty } from 'lodash-es'
import { CANCEL, DEFAULT_ERR_MSG, SAVE, SAVE_SUCCESS_MSG } from '../../constants/msgText'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import UploaderForm from '../../components/forms/input/UploaderForm'
import { doneLoading, startLoading } from '../../utils/loading'
import { downloadSubprojectFile } from '../../redux/actions/subProject'
import { SUB_PROJECT_CODE, SUB_PROJECT_ID } from '../../constants/constants'
import { saveTrackingAttach } from '../../redux/actions/subprojectTrackingHistory'
import { setAlertMessage } from '../../utils/messageUtil'
import { downloadFile, previewFile } from '../../utils/fileUtil'
import scrollToComponent from 'react-scroll-to-component'

export default function TrackingIllustration({ schema: _schema, refId, viewMode, ...props }) {
  const { theme } = React.useContext(AppContext)
  const { register, handleSubmit, errors, control, setValue, getValues, clearErrors } = useForm()

  const [section, setSection] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [formSchema, setFormSchema] = useState(_schema)
  const [attachForms, setAttachForms] = useState([])
  const [isRefash, setIsRefash] = useState(false)
  const [imgFiles, setImgFiles] = useState()
  const [deleteFile, setDeleteFile] = useState([])

  const projectCode = sessionStorage.getItem(SUB_PROJECT_CODE)
  const projectId = sessionStorage.getItem(SUB_PROJECT_ID)

  useEffect(() => {
    // console.log('formSchema => ', _schema)
    setFormSchema(_schema)
    setUpData(_schema)
    imgDownload(_schema.value)
  }, [_schema])

  const setUpData = (schema) => {
    var attachForms = []
    schema.value?.forEach((item, index) => {
      let attach = cloneDeep(schema.attachForm)

      attach.id = item.id
      attach.name = 'att_' + item.id
      attach.label += ' ' + (index + 1)
      attach.value = item.filePath

      attachForms.push(attach)
    })

    for (let index = attachForms.length; index < schema.minimum; index++) {
      let attach = cloneDeep(schema.attachForm)

      attach.id = index
      attach.name = 'att_' + index
      attach.label += ' ' + (index + 1)
      attach.value = null

      attachForms.push(attach)
    }

    setAttachForms(attachForms)
  }

  const imgDownload = async (value) => {
    // startLoading()
    if (value?.length > 0) {
      var imgs = new Map()
      for (let index = 0; index < value.length; index++) {
        if (!isEmpty(value[index].filePath)) {
          try {
            var file = await downloadSubprojectFile(value[index].filePath)
            var url = window.URL.createObjectURL(new Blob([file], { type: file.type }))

            imgs.set(value[index].id, { file: file, url: url })
          } catch (e) {
            // notification.open('error', {
            //   title: e?.response?.data?.errors?.message || DEFAULT_ERR_MSG,
            //   duration: 2500,
            // })
          }
        }
      }
      setImgFiles(imgs)
    }

    // doneLoading()
  }

  const handleSave = async (request) => {
    setIsLoading(true)
    startLoading()

    try {
      let response = await saveTrackingAttach(request)

      if (response) {
        setFormSchema(response)
        setUpData(response)
        await imgDownload(response.value)
        setDeleteFile([])
        setAlertMessage('success', SAVE_SUCCESS_MSG)
        onRefash()
        scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
      } else {
        setAlertMessage('error', DEFAULT_ERR_MSG)
      }
    } catch (e) {
      console.log('error ', e)
      setAlertMessage('error', e?.response?.data?.errors?.message || DEFAULT_ERR_MSG)
    }

    doneLoading()
    setIsLoading(false)
  }

  const onSubmit = (data) => {
    console.log('data => ', data)
    // if (data.attach?.length < formSchema.attach?.minimum) {
    //   notification.open('error', {
    //     title: `รูปภาพขั้นต่ำ ${formSchema.attach?.maximum} ภาพ`,
    //     duration: 5000,
    //   })
    // }

    const formData = new FormData()

    formData.append('Id', formSchema.id || '')
    formData.append('RefId', refId)
    formData.append('ProjectCode', projectCode || '')
    formData.append('ProjectId', projectId || '')

    let index = 0

    attachForms?.forEach((item) => {
      var files = data[item.name] || []
      if (files?.length > 0) {
        formData.append(`Imgs[${index}].Id`, item.id || null)
        formData.append(`Imgs[${index}].File`, files[0]?.blobFile || null)

        index++
      }
    })

    handleSave(formData)
  }

  const onCancel = () => {
    setUpData(formSchema)
    setDeleteFile([])
    onRefash()
    scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
  }

  const onRefash = () => {
    setIsRefash(true)
    setTimeout(() => {
      setIsRefash(false)
    }, 50)
  }

  return (
    <>
      {formSchema && (
        <Panel
          bordered
          header={formSchema.header}
          collapsible
          defaultExpanded
          ref={(section) => {
            setSection(section)
          }}
        >
          {!isRefash && (
            <>
              <FlexboxGrid style={{ marginTop: -10 }} align="top">
                {attachForms?.map((item) => {
                  return (
                    <FlexboxGrid.Item
                      componentClass={Col}
                      colspan={24}
                      xs={24}
                      sm={24}
                      md={12}
                      lg={12}
                    >
                      {!viewMode && (!item.value || deleteFile?.includes(item.id)) ? (
                        <>
                          <UploaderForm
                            single
                            schema={item}
                            register={register}
                            Controller={Controller}
                            control={control}
                            errors={errors}
                            setValue={setValue}
                            clearErrors={clearErrors}
                            disabled={isLoading || formSchema.disabled || viewMode}
                            //ignoreValidate={!isEmpty(item.value)}
                          />
                        </>
                      ) : (
                        <>
                          <p>
                            <strong>{item.label}</strong>
                          </p>
                          <div className="center" style={{ marginTop: 10 }}>
                            <div style={{ marginBottom: 10 }}>
                              {item.value ? (
                                <img
                                  src={imgFiles?.get(item.id)?.url}
                                  style={{ width: 'auto', height: '250px' }}
                                />
                              ) : (
                                <div style={{ marginTop: 125, marginBottom: 125 }}>
                                  <i>-- ไม่มีรูป --</i>
                                </div>
                              )}
                            </div>
                            <ButtonGroup>
                              {item.value && (
                                <IconButton
                                  appearance="ghost"
                                  className="rs-btn-ghost-info"
                                  icon={
                                    <Icon icon="download" className="bt-gost-icon-radius-info" />
                                  }
                                  onClick={() => {
                                    var fileNames = item.value.split('/')
                                    // onPreviewOrDownload(item.value, fileNames?.pop() || 'download', false)
                                    downloadFile(imgFiles?.get(item.id)?.file, fileNames?.pop())
                                  }}
                                />
                              )}

                              {!viewMode && (
                                <IconButton
                                  appearance="ghost"
                                  className="rs-btn-ghost-cancel"
                                  icon={
                                    <Icon
                                      icon="trash-o"
                                      className="bt-gost-icon-none-radius-cancel"
                                    />
                                  }
                                  onClick={() => {
                                    var dels = [...deleteFile, item.id]
                                    setDeleteFile(dels)
                                  }}
                                />
                              )}
                            </ButtonGroup>
                          </div>
                        </>
                      )}
                    </FlexboxGrid.Item>
                  )
                })}
              </FlexboxGrid>
            </>
          )}

          {!viewMode && (
            <>
              <hr />
              <Row style={{ marginTop: 20 }}>
                <Col lg={24} md={24} sm={24} xs={24} style={{ textAlign: 'right' }}>
                  <div style={{ paddingLeft: 40, paddingRight: 25 }}>
                    <SaveButton
                      children={SAVE}
                      disabled={isLoading}
                      onClick={handleSubmit(onSubmit)}
                    />
                    <CancelButton children={CANCEL} onClick={onCancel} />
                  </div>
                </Col>
              </Row>
            </>
          )}
        </Panel>
      )}
    </>
  )
}
